import { render, staticRenderFns } from "./IsCheckedIcon.vue?vue&type=template&id=f3485b74&scoped=true&"
import script from "./IsCheckedIcon.vue?vue&type=script&lang=js&"
export * from "./IsCheckedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3485b74",
  null
  
)

export default component.exports